<template>
  <div class="week">
    <div class="head">
      <div>
        <img src="../../../assets/images/home/1.png" alt="" />
      </div>
      <div>
        事件总数：<span>{{ detail.month }}</span
        >件
      </div>
    </div>
    <div class="body">
      <div class="item-1">
        <div>
          <template v-for="(item, index) in infoList">
            <div :key="index" v-if="item.isShow" class="list">
              <div class="v1">
                <span
                  :class="index == 0 ? 'cl-0' : index == 1 ? 'cl-1' : 'cl-2'"
                  >{{ item.name }}
                </span>
                <span
                  :class="index == 0 ? 'cl-0' : index == 1 ? 'cl-1' : 'cl-2'"
                  >{{ item.num }}</span
                >
              </div>
            </div>
          </template>
        </div>

        <div class="v2">
          <van-circle
            v-model="currentRate"
            :rate="infoList[0].info"
            :speed="60"
            :stroke-width="100"
            color="#fda143"
            size="100%"
            layer-color="#b3e3cd"
            :text="'完成率' + infoList[0].info + '%'"
          />
        </div>
      </div>
      <div class="item-2">
        <div id="mouth" style="width: 100%; height: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { getHomeCount } from "../api";
export default {
  data() {
    return {
      is_inspector: this.$store.state.user.userInfo.is_inspector,
      infoList: [
        { name: "待处理", num: "", info: "", isShow: true },
        { name: "已反馈", num: "", info: "", isShow: true },
        { name: "已完成", num: "", info: "", isShow: true },
        { name: "已存档", num: "", info: "", isShow: true },
      ],
      detail: {},
      currentRate: 0,
      rate: 0,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.chart.resize();
    });
  },
  methods: {
    init() {
      let params = {};
      getHomeCount(params).then((res) => {
        console.log("res", res.data);
        this.detail = res.data.months;
        this.infoList[0].num = this.detail.month_1;
        this.infoList[0].info = this.detail.month_1_per;
        this.infoList[1].num = this.detail.month_2;
        this.infoList[1].info = this.detail.month_2_per;
        this.infoList[2].num = this.detail.month_3;
        this.infoList[2].info = this.detail.month_3_per;
        this.infoList[3].num = this.detail.month_4;
        if (!this.is_inspector) {
          this.infoList[3].isShow = false;
        }
        this.draw(this.detail.month_area);
      });
    },
    draw(barData) {
      this.chart = echarts.init(document.getElementById("mouth"));
      this.chart.setOption({
        title: {
          text: "督查事件类型分析",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },

        series: [
          {
            name: "文明城市管理",
            type: "pie",
            radius: [20, 60],
            center: ["50%", "50%"],
            data: barData,
            label: {
              normal: {
                position: "outer",
                alignTo: "edge",
                margin: 10,
              },
            },
            // top: 20,
            grid: {
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            },
            color: [
              "#e77887",
              "#a47bad",
              "#ea8a7f",
              "#c49a8f",
              "#7a7fb5",
              "#2c81ab",
              "#6bc6ac",
              "#05a9c6",
              "#c6b03a",
              "#dcd694",
            ],
          },
        ],
      });
    },
  },
};
</script>

<style lang="less" scoped>
.week {
  .head {
    width: 100%;
    height: 2.9rem;
    background-image: url("../../../assets/images/home/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    padding: 0 0.3rem;
    > div:first-child {
      width: 1.14rem;
      height: 1.14rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    > div:last-child {
      margin-left: 0.3rem;
      color: #fff;
      span {
        font-size: 0.8rem;
        margin-left: 0.2rem;
      }
    }
  }
  .body {
    width: 100%;
    padding: 0 0.2rem;
    position: relative;
    top: -0.5rem;
    .item-1 {
      width: 100%;
      height: 2.14rem;
      background-color: #fff;
      border-radius: 0.16rem;
      text-align: center;
      .v2 {
        width: 1.2rem;
        height: 1.2rem;
        margin: 0.2rem auto 0;
        /deep/ .van-circle__text {
          font-size: 0.24rem;
        }
      }
      > div:first-child {
        display: flex;
        > div {
          flex: 1;
          .v1 {
            span:first-child {
              font-size: 0.24rem;
            }
            span:last-child {
              font-size: 0.5rem;
            }
            .cl-0 {
              color: #fe4718;
            }
            .cl-1 {
              color: #fda143;
            }
            .cl-2 {
              color: #1883fe;
            }
          }
        }
      }
    }
    .item-2 {
      width: 100%;
      height: 7rem;
      background-color: #fff;
      border-radius: 0.16rem;
      margin-top: 0.3rem;
      padding: 0.14rem 0;
    }
  }
}
</style>